const TUNNEL_VARIANT_ID = 55239270302074;
const DROP_CELL_SHAPE_VARIANT_ID = 56037850284410;

function createConfigId() {
  return 'cfg_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 8);
}

function configProps(configId, role) {
  if (!configId) return undefined;
  return { _config_id: configId, _role: role };
}

const addUpsells = async (id, configId, role) => {
  try {
    const item = { id, quantity: 1 };
    const properties = configProps(configId, role || 'extra');
    if (properties) item.properties = properties;
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: [item] }),
    });

    if (!response.ok) {
      throw new Error(
        `Ошибка при добавлении upsell: ${response.statusText}`
      );
    } 

    const result = await response.json();
  } catch (error) {
    console.error("Ошибка в addUpsells:", error);
  }
}
const addDropCellShape = async (id, configId) => {
  try {
    const item = { id, quantity: 1 };
    const properties = configProps(configId, 'drop');
    if (properties) item.properties = properties;
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: [item] }),
    });

    if (!response.ok) {
      throw new Error(
        `Ошибка при добавлении drop cell shape: ${response.statusText}`
      );
    }

    const result = await response.json();
  } catch (error) {
    console.error("Ошибка в addDropCellShape:", error);
  }
};

// Dodatki (podpietki, dodatki, doplata Krople) ida JEDNYM zadaniem i DOPIERO po udanym
// dodaniu kompletu. Do 2026-09 szly PRZED kompletem, kazdy osobnym zadaniem: drugi klik
// „Dodaj do koszyka" w oknie przekierowania dokladal podpietke z nowym _config_id, a jej
// komplet ubijala nawigacja — klient dostawal 2 podpietki (22 zamowienia od 17.08).
const addAddonsBatch = async (items) => {
  if (!items || !items.length) return;
  const wyslij = async (lista) => {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: lista }),
    });
    if (!response.ok) throw new Error(`Blad dodawania dodatkow: ${response.status}`);
    return response.json();
  };
  try {
    await wyslij(items);
  } catch (error) {
    // add.js z lista jest "wszystko albo nic" — gdy jeden dodatek jest niedostepny,
    // reszta nie moze na tym ucierpiec: dokladamy pojedynczo, jak dawniej.
    console.error("addAddonsBatch (partia):", error);
    for (const item of items) {
      try { await wyslij([item]); } catch (e) { console.error("addAddonsBatch (pojedynczo):", e); }
    }
  }
};

// Объявление кастомного элемента product-form
if (!customElements.get('product-form')) {
 
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.initializeElements();
      this.setupEventListeners();
    }

    initializeElements() {
      
      this.getContactsForm = document.querySelector('#popupOverlayGetContacts');
      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('button[name="add"]') || this.querySelector('.product-form__submit') || this.querySelector('button[type="submit"]');
      if (!this.submitButton) return;
      if (this.cart && document.querySelector('cart-drawer')) {
        this.submitButton.setAttribute('aria-haspopup', 'dialog');
      }
      this.responseProduct = '';
      const showNotification = document.querySelector('.showNotification');
      if (showNotification) showNotification.addEventListener('click', () => {
        this.cart.renderContents(this.responseProduct);
        this.getContactsForm.classList.remove('show');
        document.querySelector('html').classList.remove('overflow-hidden')
        setTimeout(() => { this.cart.querySelector('#cart-notification').classList.add('active'); }, 200);
      });
    }

    setupEventListeners() {
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();
      // Проверка чекбокса
      // const termsCheckbox = document.getElementById("newsletter-checkbox");
      // const messageField = document.querySelector("#message");
      // if (!termsCheckbox || !termsCheckbox.checked) {
      //   // Показать сообщение об ошибке
      //   messageField.innerText = "Musisz zaakceptować politykę prywatności i regulamin.";
      //   messageField.style.display = "block";
      //   return; // Прекратить выполнение, если чекбокс не отмечен
      // } else {
      //   // Скрыть сообщение об ошибке, если чекбокс отмечен
      //   messageField.innerText = "";
      //   messageField.style.display = "none";
      // }
      const matPatternInputChecked = document.querySelector('[data-type="matPattern"] input:checked')

      if (this.submitButton.getAttribute("aria-disabled") === "true") return;

      if (this.handleErrorMessage() == false) {
        return;
      }

      this.submitButton.setAttribute("aria-disabled", true);
      this.submitButton.classList.add("loading");
      this.querySelector(".loading-overlay__spinner").classList.remove("hidden");
      this.evmRedirecting = false;

      const config = fetchConfig("javascript");
      config.headers["X-Requested-With"] = "XMLHttpRequest";
      delete config.headers["Content-Type"];

      const root = this.closest(".product") || document;
      const reenabled = [];
      try {
        root.querySelectorAll('[name^="properties["]').forEach((el) => {
          if (el.disabled) {
            el.disabled = false;
            reenabled.push(el);
          }
        });
      } catch (e) {}

      const formData = new FormData(this.form);
      const configId = createConfigId();
      formData.set('properties[_config_id]', configId);
      formData.set('properties[_role]', 'main');

      // Force all line-item properties from the product DOM into FormData.
      // Fields live outside <form> via form="product-form-…" and are often
      // hidden when steps are .done — browsers can omit them from FormData.
      try {
        const byName = new Map();
        root.querySelectorAll('[name^="properties["]').forEach((el) => {
          const name = el.getAttribute("name");
          if (!name) return;
          if (!byName.has(name)) byName.set(name, []);
          byName.get(name).push(el);
        });

        byName.forEach((els, name) => {
          const first = els[0];
          if (!first) return;

          if (first.type === "radio") {
            const checked = els.find((el) => el.checked);
            if (checked && checked.value !== "") {
              formData.set(name, checked.value);
            }
            return;
          }

          if (first.type === "checkbox") {
            const checkedBoxes = els.filter((el) => el.checked);
            formData.delete(name);
            checkedBoxes.forEach((el) => formData.append(name, el.value));
            return;
          }

          // select / textarea / text / hidden — prefer non-empty when duplicates exist
          const withValue = els.find((el) => String(el.value || "").trim() !== "") || first;
          if (withValue && withValue.value != null && String(withValue.value).trim() !== "") {
            formData.set(name, withValue.value);
          }
        });
      } catch (e) {
        console.error("product-form properties safety error:", e);
      } finally {
        reenabled.forEach((el) => {
          el.disabled = true;
        });
      }

      if (this.cart) {
        formData.append(
          "sections",
          this.cart.getSectionsToRender().map((section) => section.id)
        );
        formData.append("sections_url", window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;
      const productUpsell = document.querySelector(".product__dropdown_wr--heel .product__upsell");
      const upsellItems = productUpsell
        ? productUpsell.querySelectorAll(".product__upsell_item")
        : [];

      const evmAddons = [];
      const evmAddon = (id, role) => {
        if (!id) return;
        evmAddons.push({ id, quantity: 1, properties: configProps(configId, role) });
      };

      if (productUpsell) {
        for (const item of upsellItems) {
          const input = item.querySelector("input[type='checkbox']");
          if (input && input.checked) evmAddon(input.value, 'heel');
        }
      }

      const extrasWr = document.querySelector(".product__dropdown_wr--extras");
      if (extrasWr) {
        const extrasChecked = extrasWr.querySelectorAll("input[name='product__extras']:checked");
        for (const input of extrasChecked) {
          if (input.value) evmAddon(input.value, 'extra');
        }
      }

      if (matPatternInputChecked) {
        // Doplata za „Krople” dotyczy dywanikow, nie podpietek — podpietka dostaje
        // ten sam ksztalt komorek co komplet, ale bez doplaty.
        const evmPath = decodeURIComponent(window.location.pathname)
          .normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
        const evmIsHeelPadPage = evmPath.includes('podpietka');
        if (!evmIsHeelPadPage && matPatternInputChecked.getAttribute('data-value') == 'drop') {
          evmAddon(DROP_CELL_SHAPE_VARIANT_ID, 'drop');
        }
      }

      await fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then(async (response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            const soldOutMessage = this.submitButton.querySelector(
              ".sold-out-message"
            );
            if (soldOutMessage) {
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
            }
            return;
          }

          // Komplet jest juz w koszyku — dopiero teraz dodatki, tym samym _config_id.
          await addAddonsBatch(evmAddons);

          if (!this.cart) {
            const evmCartUrl = (window.routes && window.routes.cart_url)
              || (typeof routes !== 'undefined' && routes.cart_url)
              || (/^en(?:-|$)/i.test(document.documentElement.lang || '') ? '/en/cart' : '/cart');
            // Przycisk zostaje zablokowany az do przeladowania strony; gdyby nawigacja
            // z jakiegos powodu nie nastapila, po 8 s odblokowujemy, zeby nie zamurowac karty.
            this.evmRedirecting = true;
            window.setTimeout(() => {
              this.evmRedirecting = false;
              this.submitButton.classList.remove("loading");
              this.submitButton.removeAttribute("aria-disabled");
              const sp = this.querySelector(".loading-overlay__spinner");
              if (sp) sp.classList.add("hidden");
            }, 8000);
            window.location.assign(evmCartUrl);
            return;
          }

          if (!this.error)
            publish(PUB_SUB_EVENTS.cartUpdate, { source: "product-form" });
          this.error = false;
          const quickAddModal = this.closest("quick-add-modal");
          if (quickAddModal) {
            document.body.addEventListener(
              "modalClosed",
              () => {
                setTimeout(() => {
                  this.cart.renderContents(response);
                });
              },
              { once: true }
            );
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response); // open notification
            this.responseProduct = response;
            // if (this.getContactsForm) {
            //   this.getContactsForm.classList.add('show');
            //   document.querySelector('html').classList.add('overflow-hidden')
            // }
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          if (this.evmRedirecting) return;
          this.submitButton.classList.remove("loading");
          if (this.cart && this.cart.classList.contains("is-empty")) {
            this.cart.classList.remove("is-empty");
          }
          if (!this.error) this.submitButton.removeAttribute("aria-disabled");
          this.querySelector(".loading-overlay__spinner").classList.add("hidden");
        });
      
      
    }

    handleErrorMessage() {
      const productRoot = this.closest('.product.config_container');
      const productType = productRoot && productRoot.getAttribute('data-type');
      if (productType === 'universal' || productType === 'corners') {
        return true;
      }

      let formValid = true;
      let firstInvalidElement = null;
    
      function validateRequiredGroups() {
        // Выбираем только обязательные поля, которые не находятся внутри опциональных шагов
        const requiredElements = Array.from(
          document.querySelectorAll('.product__info-container input[required], .product__info-container select[required]')
        ).filter(el => !el.closest('.product__dropdown_wr--hell'));
        
        const groups = new Map();
    
        requiredElements.forEach((element) => {
          const fieldset = element.closest('fieldset');
          if (fieldset) {
            if (!groups.has(fieldset)) {
              groups.set(fieldset, []);
            }
            groups.get(fieldset).push(element);
          }
        });
    
        groups.forEach((elements, fieldset) => {
          let groupValid = elements.some(element => {
            if (element.type === 'radio' || element.type === 'checkbox') {
              return element.checked;
            } else if (element.type === 'select-one') {
              return element.value;
            } else if (element.type === 'text') {
              return element.value.trim() !== '';
            }
            return false;
          });
    
          const errorMessage = fieldset.querySelector('.error-message');
          if (!groupValid) {
            if (errorMessage) {
              errorMessage.style.display = 'block';
            }
            formValid = false;
            if (!firstInvalidElement) {
              firstInvalidElement = fieldset;
            }
          } else {
            if (errorMessage) {
              errorMessage.style.display = 'none';
            }
          }
        });
      }
    
      validateRequiredGroups();
    
      // Проверяем обязательные шаги: пропускаем шаги, которые находятся внутри опциональных контейнеров
      const steps = Array.from(
        document.querySelectorAll('product-info .product__dropdown_inner')
      ).filter(step => !step.closest('.product__dropdown_wr--heel') && !step.closest('.product__dropdown_wr--extras'));
    
      steps.forEach(step => {
        if (!step.classList.contains('super_done')) {
          // Если шаг не завершён, отмечаем форму как невалидную
          formValid = false;
          if (!firstInvalidElement) {
            firstInvalidElement = step.closest('.product__dropdown_wr');
          }
        }
      });
    
      if (!formValid) {
        if (firstInvalidElement) {
          const offsetTop = firstInvalidElement.getBoundingClientRect().top + window.scrollY - 100;
          window.scrollTo({ top: offsetTop, behavior: 'smooth' });
        }
        return false;
      } else {
        return true;
      }
    }
    
    
  });
}

// Логика для кнопки "Купить сейчас"
// const buyNowButton = document.getElementById('add-to-cart-and-checkout');
// const productUpsell = document.querySelector('.product__upsell');

// const validateCheckbox = () => {
//   const termsCheckbox = document.getElementById('newsletter-checkbox');
//   const messageField = document.querySelector('#message');

//   if (!termsCheckbox || !termsCheckbox.checked) {
//     messageField.innerText = 'Musisz zaakceptować politykę prywatności i regulamin.';
//     messageField.style.display = 'block';
//     return false;
//   } else {
//     messageField.innerText = '';
//     messageField.style.display = 'none';
//     return true;
//   }
// };
// const addToCart = async () => {
//   try {
//     const properties = {};
//     const attributes = {}

//     const rokProdukcji = document.querySelector('[name="properties[Rok produkcji: *]"]');
//     if (rokProdukcji) properties['Rok produkcji'] = rokProdukcji.value;

//     // const matsType = document.querySelector('[name="Rodzaj dywaników"]:checked');
//     // if (matsType) properties['Rodzaj dywaników'] = matsType.value;

//     // const matsSet = document.querySelector('[name="Zestaw"]:checked');
//     // if (matsSet) properties['Zestaw'] = matsSet.value;

//     const cellShape = document.querySelector('[name="properties[Ksztalt komorek]"]:checked');
//     if (cellShape) properties['Ksztalt komorek'] = cellShape.value;

//     const materialColor = document.querySelector('[name="properties[Kolor materialu]"]:checked');
//     if (materialColor) properties['Kolor materialu'] = materialColor.value;

//     const trimColor = document.querySelector('[name="properties[Kolor obszycia]"]:checked');
//     if (trimColor) properties['Kolor obszycia'] = trimColor.value;

//     const brand = document.querySelector('[name="properties[Marka samochodu]"]');
//     if (brand) properties['Marka samochodu'] = brand.value;

//     const model = document.querySelector('[name="properties[Model samochodu]"]');
//     if (model) properties['Model samochodu'] = model.value;

//     const bodyType = document.querySelector('[name="properties[Typ nadwozia]"]:checked');
//     if (bodyType) properties['Typ nadwozia'] = bodyType.value

//     const orderNotes = document.querySelector('#uwagi-do-zamowienia');
//     if (orderNotes) properties['Uwagi do zamówienia'] = orderNotes.value;
    
//     const outlet = document.querySelector('[name="attributes[Outlet]"]');
//     if (outlet) attributes['Outlet'] = outlet.value;
    
//     const bitrixCollection = document.querySelector('[name="properties[_collection]"]');
//     if (bitrixCollection) properties['_collection'] = bitrixCollection.value;

//     // const liczbaMiejsc = document.querySelector('[name="properties[Liczba miejsc: *]"]');
//     // if (liczbaMiejsc) properties['Liczba miejsc:'] = liczbaMiejsc.value;

//     // const napedMaszyny = document.querySelector('[name="properties[Napęd maszyny]"]:checked');
//     // if (napedMaszyny) properties['Napęd maszyny:'] = napedMaszyny.value;

//     const productId = document.querySelector('.product-form [name="id"]').value;
//     // const quantity = document.querySelector('.product-form__quantity .quantity__input').value;

//     const quantity = document.querySelector('product-info .quantity__input').value;
//     const response = await fetch('/cart/add.js', {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({
//         id: productId,
//         quantity: quantity,
//         properties: properties,
//         attributes: attributes
//       })
//     });

//     if (!response.ok) {
//       throw new Error('Ошибка при добавлении в корзину');
//     }

//     const result = await response.json();
//     await addTunel()

//     // Перенаправление на страницу оформления заказа
//     setTimeout(() => {
//       window.location.href = '/checkout';      
//     }, 100);
//   } catch (error) {
//     console.error('Ошибка при добавлении товара в корзину:', error);
//     alert('Error. Try again');
//   }
// };

// if (buyNowButton) {
//   buyNowButton.addEventListener('click', async (event) => {
//     event.preventDefault();

//     if (!validateCheckbox()) {
//       return;
//     }

//     const productFormElement = document.querySelector('product-form');
//     if (productFormElement && !productFormElement.handleErrorMessage()) {
//       return;
//     }

//     const upsellItems = productUpsell ? productUpsell.querySelectorAll('.product__upsell_item') : [];
//     for (const item of upsellItems) {
//       const input = item.querySelector('input[type="checkbox"]');
//       if (input && input.checked) {
//         const upsellId = input.value;
//         await addUpsells(upsellId);
//       }
//     }

//     await addToCart();
//   });
// }


// Emergency guard for custom configurator layouts: the visible add-to-cart
// button inside universal/corners cards must submit the product form, not act as
// a configurator "next" button.
document.addEventListener('click', function(event) {
  if (!event.target || !event.target.closest) return;

  const root = event.target.closest('.product.config_container[data-type="universal"], .product.config_container[data-type="corners"]');
  if (!root) return;

  const button = event.target.closest('product-form .product-form__submit[name="add"], product-form .product-form__submit');
  if (!button || !root.contains(button) || button.disabled || button.getAttribute('aria-disabled') === 'true') return;

  const productForm = button.closest('product-form');
  const form = productForm && productForm.querySelector('form[action*="/cart/add"]');
  if (!form || form.dataset.evmSubmitting === 'true') return;

  event.preventDefault();
  event.stopImmediatePropagation();
  form.dataset.evmSubmitting = 'true';
  form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
  setTimeout(function() {
    delete form.dataset.evmSubmitting;
  }, 1200);
}, true);
